import { apiSlice } from "../../app/api/apiSlice";

export const providerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    setGlobalVisitsPerDay: builder.mutation({
      query: (credentials) => ({
        url: "/provider/constraint/global/visits-per-day",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    upsertProviderConstraint: builder.mutation({
      query: (credentials) => ({
        url: `/provider/constraint/${credentials.id}`,
        method: "POST",
        body: { ...credentials.data },
      }),
    }),
    fetchProviderLeaves: builder.mutation({
      query: (credentials) => `/provider/leave/${credentials.id}`,
      method: "GET",
    }),
    createProviderLeave: builder.mutation({
      query: (credentials) => ({
        url: `/provider/leave/${credentials.id}`,
        method: "POST",
        body: { ...credentials.data },
      }),
    }),
    setGlobalStartEndDate: builder.mutation({
      query: (credentials) => ({
        url: `/provider/constraint/global/start-end-date`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    updateProviderLeave: builder.mutation({
      query: (credentials) => ({
        url: `/provider/leave/${credentials.id}`,
        method: "PATCH",
        body: { ...credentials.data },
      }),
    }),
    updateProviderMissingFields: builder.mutation({
      query: (credentials) => ({
        url: `/provider/update/missing/${credentials.id}`,
        method: "PATCH",
        body: { ...credentials.data },
      }),
    }),
    removeProviderLeave: builder.mutation({
      query: (credentials) => ({
        url: `/provider/leave/${credentials.id}`,
        method: "DELETE",
      }),
    }),
    fetchProviderCareplans: builder.mutation({
      query: (credentials) => ({
        url: `/provider/careplans/${credentials?.id}?market=${credentials?.marketId}`,
        method: "GET",
      }),
    }),
    fetchProviderById: builder.mutation({
      query: (credentials) => ({
        // url: `/provider/${credentials}`,
        url: `/provider/${credentials?.id}?market=${credentials?.marketId}`,
        method: "GET",
      }),
    }),
    createProvider: builder.mutation({
      query: (credentials) => ({
        url: `/provider/`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    deleteProvider: builder.mutation({
      query: (credentials) => ({
        url: `/provider/${credentials.id}`,
        method: "DELETE",
      }),
    }),
    fetchProviderCommunities: builder.mutation({
      query: (credentials) => ({
        url: `/provider/locations/${credentials?.id}?market=${credentials?.marketId}`,
        method: "GET",
      }),
    }),
    getProviderAvailability: builder.mutation({
      query: (credentials) => ({
        url: `/provider/monthly-availability/${credentials?.id}?indexDate=${credentials?.indexDate}&&marketId=${credentials?.market_id}`,
        method: "GET",
      }),
    }),
    upsertProviderAvailability: builder.mutation({
      query: (credentials) => ({
        url: `/provider/monthly-availability/${credentials?.id}`,
        method: "PATCH",
        body: { ...credentials?.data },
      }),
    }),
    fetchProviderCommunityRules: builder.mutation({
      query: (credentials) => ({
        url: `/provider/provider-community-rules/${credentials}`,
        method: "GET",
      }),
    }),
    upsertProviderCommunityRules: builder.mutation({
      query: (credentials) => ({
        url: "/provider/provider-community-rules",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    removeProviderCommunityRules: builder.mutation({
      query: (credentials) => ({
        url: "/provider/provider-community-rules",
        method: "DELETE",
        body: { ...credentials },
      }),
    }),
    fetchProviderPatientRules: builder.mutation({
      query: (credentials) => ({
        url: `/provider/provider-patient-rules/${credentials}`,
        method: "GET",
      }),
    }),
    upsertProviderPatientRules: builder.mutation({
      query: (credentials) => ({
        url: "/provider/provider-patient-rules",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    removeProviderPatientRules: builder.mutation({
      query: (credentials) => ({
        url: "/provider/provider-patient-rules",
        method: "DELETE",
        body: { ...credentials },
      }),
    }),
    fetchPlannerProviders: builder.mutation({
      query: (credentials) => ({
        url: `/provider/planner`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    updateProvider: builder.mutation({
      query: (credentials) => ({
        url: `/provider/${credentials.providerId}`,
        method: "PUT",
        body: credentials,
      }),
    }),
    fetchProviderZones: builder.mutation({
      query: (credentials) => ({
        url: `/provider/zone-locations/${credentials}`,
        method: "GET",
      }),
    }),
    fetchProviderZipCodes: builder.mutation({
      query: (credentials) => ({
        url: `/provider/zip-codes/${credentials?.providerId}?marketId=${credentials?.marketId}`,
        method: "GET",
      }),
    }),
    addWeeklyDateRange: builder.mutation({
      query: (credentials) => ({
        url: `/provider/weekly-date-range/${credentials.id}`,
        method: "POST",
        body: credentials,
      }),
    }),

    createAvTemplate: builder.mutation({
      query: (credentials) => ({
        url: `/provider/create-availability-template/${credentials.id}`,
        method: "POST",
        body: credentials,
      }),
    }),
    getWeeklyDateRange: builder.mutation({
      query: (credentials) => ({
        // url: `/provider/get-weekly-date-range/${credentials.id}`,
        url: `/provider/get-weekly-date-range/${credentials.id}?market_id=${credentials?.market_id ?? null}`,
        method: "GET",
        // body: credentials,
      }),
    }),

    deleteWeeklyDateRange: builder.mutation({
      query: (credentials) => ({
        url: `/provider/delete-weekly-dateRange/${credentials.provider_id}?id=${credentials.id}`,
        method: "DELETE",
      }),
    }),

    validateDeletedDates: builder.mutation({
      query: (credentials) => ({
        url: `/provider/validate-deleted-dates`,
        method: "POST",
        body: credentials,
      }),
    }),
    deleteAssignment: builder.mutation({
      query: (credentials) => ({
        url: `/provider/delete-dateRange/${credentials.provider_id}?id=${credentials.id}`,
        method: "DELETE",
      }),
    }),
    uploadCompanyWideAbsence: builder.mutation({
      // query: (credentials) => ({

      // }),

      query: (credentials) => {
        const formData = new FormData();

        // Append file
        if (credentials.file) {
          formData.append("file", credentials.file);
        }

        // Append other fields
        Object.keys(credentials).forEach((key) => {
          if (key !== "file") {
            formData.append(key, credentials[key]);
          }
        });
        return {
          url: `/provider/upload-componey-wide-absence/${credentials.organisationId}`,
          method: "POST",
          // body:credentials
          body: formData,
          // Add this flag to indicate it's FormData
          headers: {
            // DO NOT manually set `Content-Type`, the browser will handle it
          },
        };
      },
    }),
    uploadProviderAvailability: builder.mutation({
      // query: (credentials) => ({

      // }),

      query: (credentials) => {
        const formData = new FormData();
        // Append file
        if (credentials.file) {
          formData.append("file", credentials.file);
        }
        // Append other fields
        Object.keys(credentials).forEach((key) => {
          if (key !== "file") {
            formData.append(key, credentials[key]);
          }
        });
        return {
          url: `/provider/upload-provider-availability/${credentials.organisationId}`,
          method: "POST",
          // body:credentials
          body: formData,
          // Add this flag to indicate it's FormData
          headers: {
            // DO NOT manually set `Content-Type`, the browser will handle it
          },
        };
      },
    }),
  }),



});

export const {
  useSetGlobalVisitsPerDayMutation,
  useUpsertProviderConstraintMutation,
  useFetchProviderLeavesMutation,
  useCreateProviderLeaveMutation,
  useUpdateProviderLeaveMutation,
  useUpdateProviderMissingFieldsMutation,
  useRemoveProviderLeaveMutation,
  useFetchProviderCareplansMutation,
  useFetchProviderByIdMutation,
  useSetGlobalStartEndDateMutation,
  useCreateProviderMutation,
  useDeleteProviderMutation,
  useFetchProviderCommunitiesMutation,
  useGetProviderAvailabilityMutation,
  useUpsertProviderAvailabilityMutation,
  useFetchProviderCommunityRulesMutation,
  useUpsertProviderCommunityRulesMutation,
  useRemoveProviderCommunityRulesMutation,
  useFetchProviderPatientRulesMutation,
  useUpsertProviderPatientRulesMutation,
  useRemoveProviderPatientRulesMutation,
  useFetchPlannerProvidersMutation,
  useUpdateProviderMutation,
  useFetchProviderZonesMutation,
  useAddWeeklyDateRangeMutation,
  useGetWeeklyDateRangeMutation,
  useDeleteWeeklyDateRangeMutation,
  useFetchProviderZipCodesMutation,

  useUploadCompanyWideAbsenceMutation,
  useUploadProviderAvailabilityMutation,
  useCreateAvTemplateMutation,

  useDeleteAssignmentMutation,

  useValidateDeletedDatesMutation
} = providerApiSlice;
